module.exports = __webpack_public_path__ + "img/fruit-peaches-190x100.2b4fa15d.jpg";